import { useState, useEffect, useRef, useCallback } from "react";
import PageHeader from "../../component/pageHeaders/index";
import { useNavigate } from "react-router-dom";
import "./style.css";
import DataTableBanner from "./component/dataTable";
import { API } from "../../config/API";
import axios from "../../config/axiosInstance";
import Loadingbox from "../../component/loadingbox";
import { PUT } from "../../utils/apirequest";
import { CloseCircleOutlined, FilterOutlined } from "@ant-design/icons";

import { Button, DatePicker, Drawer, Input, Select, Tag, message } from "antd";
import moment from "moment";
import { LoadCategories } from "../../utils/commonapis";

const BannerScreen = () => {
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(true);
  const [show, setShow] = useState(false);
  const [meta, setMeta] = useState();
  const [page, setPage] = useState(1);
  const [trashcount, setTrashcount] = useState();
  const [publishCount, setPublishCount] = useState();
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [categoryList, setCategoryList] = useState<any[]>([]);
  const [tag, setTAg] = useState<any[]>([]);
  const [indicator, setIndicator] = useState<boolean>(true);
  const [filter, setFilter] = useState({ start: 0, limit: pageSize }) as any;
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [filterLabels, setFilterLabels] = useState<any>({});
  const [selectedCategory, setSelectedCategory] = useState<any>(undefined);
  const [selectedTag, setSelectedTag] = useState<any>(undefined);
  const [selectedStatus, setSelectedStatus] = useState<any>(undefined);
  const [selectedDate, setSelectedDate] = useState<any>(null);

  useEffect(() => {
    loadData(filter);
    loadCategories();
    loadTag();
  }, []);

  const loadData = (filter: any) => {
    setIndicator(true);
    let url = API.BASE_URL + API.GET_BANNERS;
    axios
      .post(url, filter)
      .then((response) => {
        let imageData = response.data.data;
        let metaData = response.data?.totalCount;
        setData(imageData);
        setPublishCount(response.data?.publishedCount);
        setTrashcount(response.data?.trashedCount);
        setMeta(metaData);
        setIsloading(false);
        setIndicator(false);
      })
      .catch((error) => {
        console.log(error);
        setIsloading(false);
      });
  };
  const loadCategories = async () => {
    try {
      const res: any = await LoadCategories();
      setCategoryList(res?.data || []);
    } catch (err) {
      setCategoryList([]);
    }
  };

  const loadTag = () => {
    let url =
      API.BASE_URL + API.TAGS_LIST + `?pagination[page]=1&pagination[pageSize]=100`;
    return axios
      .get(url)
      .then((response) => {
        setTAg(response.data?.data || []);
        return response.data;
      })
      .catch((error) => {
        console.error("Failed to load tags:", error);
      });
  };

  const addToTrash = async (val: any) => {
    let url = API.BANNERS + `/${val.id}`;
    let obj = {
      data: {
        is_deleted: true,
      },
    };
    let res: any = await PUT(url, obj);
    if (res?.data?.id) {
      message.success("Sucesssfully moved to trash");
      loadData(filter);
    } else {
      message.error("Something went wrong...!");
    }
  };

  const UndoTrash = async (val: any) => {
    let url = API.BANNERS + `/${val.id}`;
    let obj = {
      data: {
        is_deleted: false,
      },
    };
    let res: any = await PUT(url, obj);
    if (res?.data?.id) {
      message.success("Sucesssfully Recovered from trash");
      loadData(filter);
    } else {
      message.error("Something went wrong...!");
    }
  };

  const onPageChange = (page: any, pageSize: any) => {
    window.scrollTo(0, 0);
    let take = page === 1 ? 0 : page * 10 - 10;
    setPage(page);
    setPageSize(pageSize);
    let filters = {
      ...filter,
      start: take,
      limit: pageSize,
    };
    loadData(filters);
  };

  const searchTimer = useRef<any>(null);
  const Search = useCallback((searchText: any) => {
    if (searchTimer.current) clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      if (searchText) {
        let filters = { ...filter, search: searchText };
        setFilter(filters);
        loadData(filters);
      } else {
        const { search, ...rest } = filter;
        setFilter(rest);
        loadData(rest);
      }
    }, 500);
  }, [filter]);
  const onChangeDate = (date: any, datestring: any) => {
    if (date) {
      let filters = {
        ...filter,
        createdAt: date,
      };
      setFilter(filters);
      loadData(filters);
      setSelectedDate(date);
      setFilterLabels((prev: any) => ({ ...prev, createdAt: moment(date).format("DD-MM-YYYY") }));
    }
  };

  const LoadPublished = () => {
    let filters = {
      ...filter,
      type: "published",
    };
    setFilter(filters);
    loadData(filters);
  };

  const LoadTrashed = () => {
    let filters = {
      ...filter,
      type: "trash",
    };
    setFilter(filters);
    loadData(filters);
  };

  const clearFilters = (key: any) => {
    const updatedFilter = { ...filter };
    delete updatedFilter[key];
    setFilter(updatedFilter);
    loadData(updatedFilter);
    const updatedLabels = { ...filterLabels };
    delete updatedLabels[key];
    setFilterLabels(updatedLabels);
    if (key === "catId") setSelectedCategory(undefined);
    if (key === "tagId") setSelectedTag(undefined);
    if (key === "handleShow") setSelectedStatus(undefined);
    if (key === "createdAt") setSelectedDate(null);
  };
  const clearAllFilters = () => {
    const base = { start: 0, limit: pageSize };
    setFilter(base);
    loadData(base);
    setFilterLabels({});
    setSelectedCategory(undefined);
    setSelectedTag(undefined);
    setSelectedStatus(undefined);
    setSelectedDate(null);
  };
  const CategoryChange = (category: any, option?: any) => {
    let filters = {
      ...filter,
      catId: category,
    };
    setFilter(filters);
    loadData(filters);
    setSelectedCategory(category);
    setFilterLabels((prev: any) => ({ ...prev, catId: option?.children || category }));
  };
  const TAgChange = (tagId: any, option?: any) => {
    let filters = {
      ...filter,
      tagId: tagId,
    };
    setFilter(filters);
    loadData(filters);
    setSelectedTag(tagId);
    setFilterLabels((prev: any) => ({ ...prev, tagId: option?.children || tagId }));
  };
  const Live = (prio: any) => {
    let filters = {
      ...filter,
      handleShow: prio,
    };
    setFilter(filters);
    loadData(filters);
    setSelectedStatus(prio);
    setFilterLabels((prev: any) => ({ ...prev, handleShow: prio === "true" ? "Live" : "Not in Live" }));
  };

  const onEdit = (val: any) => {
    navigate(`/Auth/banner/Create`, { state: { items: val } });
  };

  return (
    <>
      <div style={{ height: "90vh", overflow: "scroll" }}>
        <PageHeader title={"Banner"} loader={indicator} length={`${meta || 0} Banners`}>
          <div className="banner-header-actions">
            <Input
              allowClear
              placeholder="Search Banner"
              className="banner-header-search"
              onChange={(e: any) => Search(e.target.value)}
            />
            <div className="homescreen-pageBox">
              <div
                className="homescreen-pageItem"
                onClick={() => LoadPublished()}
                style={{ cursor: "pointer" }}
              >
                <span style={{ color: "green" }}>Published</span> :&nbsp;
                <b>{publishCount}</b>
              </div>
              |
              <div
                className="homescreen-pageItem"
                onClick={() => LoadTrashed()}
                style={{ cursor: "pointer" }}
              >
                <span style={{ color: "red" }}>Trashed</span> :&nbsp;
                <b>{trashcount}</b>
              </div>
            </div>
            <Button
              type="primary"
              onClick={() => navigate("/Auth/banner/Create")}
            >
              New Entry +
            </Button>
          </div>
        </PageHeader>
        <div style={{ padding: 5 }} />
        <div className="banner-filter-row">
          <div className="banner-filter-labels"
          >
            <span style={{ fontSize: 13, whiteSpace: "nowrap" }}>
              {Object.keys(filterLabels)?.length > 0 ? "Filter By :" : "All Banners"}
            </span>
            {Object.keys(filterLabels)?.map((key) => (
              <Tag key={key} style={{ margin: 0 }}>
                {filterLabels[key]}{" "}
                <CloseCircleOutlined onClick={() => clearFilters(key)} />
              </Tag>
            ))}
            {Object.keys(filterLabels)?.length > 0 && (
              <Tag
                color="red"
                style={{ margin: 0, cursor: "pointer" }}
                onClick={clearAllFilters}
              >
                Clear All
              </Tag>
            )}
          </div>
          <Button
            className="banner-filter-btn-mobile"
            icon={<FilterOutlined />}
            size="small"
            onClick={() => setFilterDrawer(true)}
          >
            Filters
          </Button>
          <div className="banner-filter-desktop" style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            <DatePicker
              allowClear
              value={selectedDate}
              style={{ width: 160 }}
              onChange={onChangeDate}
            />
            <Select
              showSearch={true}
              placeholder="Category"
              value={selectedCategory}
              onChange={(val, option) => CategoryChange(val, option)}
              style={{ width: 160 }}
              allowClear
              onClear={() => clearFilters("catId")}
              filterOption={(input: any, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {categoryList.length > 0 &&
                categoryList.map((item: any, index: any) => (
                  <Select.Option key={index} value={item.id}>
                    {item.attributes.category}
                  </Select.Option>
                ))}
            </Select>
            <Select
              showSearch={true}
              placeholder="Tags"
              value={selectedTag}
              onChange={(val, option) => TAgChange(val, option)}
              style={{ width: 160 }}
              allowClear
              onClear={() => clearFilters("tagId")}
              filterOption={(input: any, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {tag.length > 0 &&
                tag.map((item: any, index: any) => (
                  <Select.Option key={index} value={item.id}>
                    {item.attributes.tag}
                  </Select.Option>
                ))}
            </Select>
            <Select
              showSearch={true}
              placeholder="Status"
              value={selectedStatus}
              onChange={(val) => Live(val)}
              style={{ width: 140 }}
              allowClear
              onClear={() => clearFilters("handleShow")}
            >
              <Select.Option key={"true"}>Live</Select.Option>
              <Select.Option key={"false"}>Not in Live</Select.Option>
            </Select>
          </div>
        </div>
        <Drawer
          title="Filters"
          placement="bottom"
          onClose={() => setFilterDrawer(false)}
          open={filterDrawer}
          height="auto"
          className="banner-filter-drawer"
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <DatePicker
              allowClear
              value={selectedDate}
              style={{ width: "100%" }}
              onChange={(date, dateString) => { onChangeDate(date, dateString); setFilterDrawer(false); }}
            />
            <Select
              showSearch={true}
              placeholder="Category"
              value={selectedCategory}
              onChange={(val, option) => { CategoryChange(val, option); setFilterDrawer(false); }}
              style={{ width: "100%" }}
              allowClear
              onClear={() => clearFilters("catId")}
              filterOption={(input: any, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {categoryList.length > 0 &&
                categoryList.map((item: any, index: any) => (
                  <Select.Option key={index} value={item.id}>
                    {item.attributes.category}
                  </Select.Option>
                ))}
            </Select>
            <Select
              showSearch={true}
              placeholder="Tags"
              value={selectedTag}
              onChange={(val, option) => { TAgChange(val, option); setFilterDrawer(false); }}
              style={{ width: "100%" }}
              allowClear
              onClear={() => clearFilters("tagId")}
              filterOption={(input: any, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {tag.length > 0 &&
                tag.map((item: any, index: any) => (
                  <Select.Option key={index} value={item.id}>
                    {item.attributes.tag}
                  </Select.Option>
                ))}
            </Select>
            <Select
              showSearch={true}
              placeholder="Status"
              value={selectedStatus}
              onChange={(val) => { Live(val); setFilterDrawer(false); }}
              style={{ width: "100%" }}
              allowClear
              onClear={() => clearFilters("handleShow")}
            >
              <Select.Option key={"true"}>Live</Select.Option>
              <Select.Option key={"false"}>Not in Live</Select.Option>
            </Select>
            {Object.keys(filterLabels)?.length > 0 && (
              <Button danger block onClick={() => { clearAllFilters(); setFilterDrawer(false); }}>
                Clear All Filters
              </Button>
            )}
          </div>
        </Drawer>
        {isLoading ? (
          <Loadingbox />
        ) : (
          <div style={{ height: "80vh", overflow: "scroll" }}>
            <DataTableBanner
              meta={meta}
              data={data}
              page={page}
              pagesize={pageSize}
              loading={indicator}
              onEdit={(val: any) => onEdit(val)}
              onTrash={(val: any) => addToTrash(val)}
              unTrash={(val: any) => UndoTrash(val)}
              refresh={() => loadData(filter)}
              onPageChange={(page: any, pageSize: any) =>
                onPageChange(page, pageSize)
              }
            />
          </div>
        )}
      </div>
    </>
  );
};

export default BannerScreen;
